var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _ellipse, _ellipse2, _ellipse3, _path15, _path16, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlanet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 807,
    height: 623,
    viewBox: "0 0 807 623",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.033 140.129C107.448 140.859 105.588 150.607 104.585 155.006C102.65 163.489 85.6251 156.961 88.2805 149.343C91.049 141.404 100.8 139.438 104.033 140.129Z",
    fill: "#313447"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193.865 351.149C178.439 414.904 124.357 454.655 73.0686 439.938C21.7808 425.219 -7.29092 361.604 8.13515 297.85C23.5612 234.096 77.6436 194.344 128.932 209.063C180.219 223.78 209.291 287.395 193.865 351.149Z",
    fill: "url(#paint0_radial_1549_20)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M692.933 377.21C732.259 305.936 712.011 217.618 647.706 179.947C583.403 142.275 499.394 169.515 460.067 240.789C420.741 312.063 440.989 400.381 505.294 438.053C569.597 475.725 653.606 448.485 692.933 377.21Z",
    fill: "url(#paint1_radial_1549_20)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M655.933 377.21C695.259 305.936 675.011 217.618 610.706 179.947C546.403 142.275 462.394 169.515 423.067 240.789C383.741 312.063 403.989 400.381 468.294 438.053C532.597 475.725 616.606 448.485 655.933 377.21Z",
    fill: "url(#paint2_radial_1549_20)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M427.561 175.658C355.782 240.803 406.09 430.78 411.331 433.869C477.855 596.909 265.986 501.562 303.486 308.407C340.984 115.253 499.34 110.513 427.561 175.658Z",
    fill: "#2C2F41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M533.103 37.001C526.936 37.001 518.575 34.2744 515.938 31.7947C510.855 27.0124 527.805 22.6579 533.737 26.4325C539.669 30.207 536.31 37.001 533.103 37.001Z",
    fill: "#313447"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M369.922 13.935C368.472 11.57 368.289 9.07363 370.66 6.5461C377.086 -0.307523 396.312 4.00705 419.174 9.13748C427.324 10.9665 435.936 12.8991 444.595 14.4664C648.14 35.0456 807 206.83 807 415.701C807 638.437 626.347 819.001 403.5 819.001C180.653 819.001 0 638.437 0 415.701C0 336.743 0.0731392 291.586 39.3074 229.393C74.6765 165.626 127.651 112.623 189.264 74.9653C197.301 68.1369 212.591 54.8938 219.597 47.8921C227.652 39.84 235.817 41.7139 240.124 48.2457C281.642 29.7806 325.667 17.956 369.922 13.935Z",
    fill: "url(#paint3_linear_1549_20)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M370.084 141.019C379.731 138.204 389.661 137.579 393.918 144.161C400.05 153.646 391.355 155.899 384.387 161.699C377.711 167.253 374.343 176.819 366.363 169.123C356.883 159.979 365.069 142.483 370.084 141.019Z",
    fill: "#313447"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M238.361 187.35C240.181 188.936 241.582 190.852 240.758 192.523C239.169 195.745 231.355 193.126 232.043 190.09C232.731 187.052 237.416 186.525 238.361 187.35Z",
    fill: "#313447"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M514.068 99.3506C516.09 100.938 517.647 102.853 516.731 104.524C514.966 107.746 506.284 105.128 507.047 102.09C507.812 99.0535 513.017 98.5257 514.068 99.3506Z",
    fill: "#313447"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M157.982 137.875C154.657 136.934 156.122 133.974 157.982 130.925C161.572 125.045 174.332 124.28 170.178 129.448C165.846 134.835 161.131 138.766 157.982 137.875Z",
    fill: "#313447"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M343.476 329.813C339.634 337.383 330.499 333.326 321.175 328.325C303.193 318.681 317.744 303.364 337.162 306.389C356.571 309.414 347.112 322.648 343.476 329.813Z",
    fill: "#313447"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M743.476 556.813C739.634 564.383 730.499 560.326 721.175 555.325C703.193 545.68 717.744 530.363 737.162 533.388C756.571 536.414 747.112 549.647 743.476 556.813Z",
    fill: "#313447"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M205.469 69.3425C207.044 70.92 208.341 72.8284 207.919 74.5052C207.106 77.739 200.851 75.1642 201.003 72.121C201.155 69.0779 204.649 68.5225 205.469 69.3425Z",
    fill: "#292C3E"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.5516,
    cy: 84.5761,
    rx: 68.5516,
    ry: 84.5761,
    transform: "matrix(0.960901 0.276894 -0.234256 0.972175 67.876 222.42)",
    fill: "url(#paint4_radial_1549_20)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.188,
    cy: 105.027,
    rx: 96.188,
    ry: 105.027,
    transform: "matrix(0.862992 0.505218 0.483363 -0.87542 428 351.885)",
    fill: "url(#paint5_radial_1549_20)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.188,
    cy: 105.027,
    rx: 96.188,
    ry: 105.027,
    transform: "matrix(0.862992 0.505218 0.483363 -0.87542 163 675.885)",
    fill: "url(#paint6_radial_1549_20)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M333.722 6.73045C403.302 -3.06747 464.656 -3.78185 456.932 26.7562C449.207 57.2943 403.302 97.74 333.722 107.538C264.143 117.336 185.478 107.528 193.203 76.9902C200.928 46.4522 264.143 16.5284 333.722 6.73045Z",
    fill: "url(#paint7_radial_1549_20)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1549_20",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 192,
    y: 0,
    width: 266,
    height: 112
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M333.722 6.73045C403.302 -3.06747 464.656 -3.78185 456.932 26.7562C449.207 57.2943 403.302 97.74 333.722 107.538C264.143 117.336 185.478 107.528 193.203 76.9902C200.928 46.4522 264.143 16.5284 333.722 6.73045Z",
    fill: "url(#paint8_radial_1549_20)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1549_20)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1549_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.165 53.9977C464.149 -18.4626 130.361 56.874 266.049 103.991C252.901 117.138 164.547 85.1758 153.348 45.7337C142.148 6.29163 172.338 22.8475 219.572 -10.2644C266.805 -43.3762 404.122 -38.5069 453.302 -37.533C502.483 -36.5592 494.692 -0.525677 499.075 16.5172C502.581 30.1515 448.443 39.8764 440.165 53.9977Z",
    fill: "url(#paint9_radial_1549_20)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1549_20",
    x: 141.011,
    y: -48.3496,
    width: 368.227,
    height: 165.343,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_1549_20"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1549_20",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(429.027 496.667) rotate(-98.8631) scale(499.681 493.366)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D3041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571667,
    stopColor: "#2B2E41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242635"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1549_20",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(717.065 305.097) rotate(144.469) scale(735.354 678.515)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60513,
    stopColor: "#2C2F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841688,
    stopColor: "#262838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252737"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1549_20",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(680.065 305.097) rotate(144.469) scale(735.354 678.515)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60513,
    stopColor: "#2C2F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841688,
    stopColor: "#262838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252737"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1549_20",
    x1: 303.22,
    y1: 20.2193,
    x2: 580.117,
    y2: 605.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A3B4E",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11111E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1549_20",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.6157 102.792) rotate(-97.2568) scale(103.08 83.7737)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D3041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.596662,
    stopColor: "#2B2E41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242635"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1549_20",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(170.862 78.2739) rotate(142.397) scale(180.167 169.928)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60513,
    stopColor: "#2C2F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841688,
    stopColor: "#262838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252737"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1549_20",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(170.862 78.2739) rotate(142.397) scale(180.167 169.928)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60513,
    stopColor: "#2C2F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841688,
    stopColor: "#262838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252737"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1549_20",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(323.368 58.5923) rotate(174.18) scale(126.371 47.9897)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343746"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974002,
    stopColor: "#3D3F4F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1549_20",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(323.368 58.5923) rotate(173.891) scale(130.834 49.6844)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791667,
    stopColor: "#313567"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E3263"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1549_20",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(318.557 2.48722) rotate(72.7185) scale(95.5486 205.205)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991667,
    stopColor: "#35384C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanet);
export default __webpack_public_path__ + "static/media/planet.33b3b4476d4f07210a27f429dc6d3a14.svg";
export { ForwardRef as ReactComponent };